import React, { useState } from 'react';
import PropTypes from 'prop-types';

import GenericTextInputField from '../../../commons/form-fields/GenericTextInputField';
import { LightBlueAlert } from '../../../commons/Alerts';
import { getBankRoutingNumberLabelByCountry } from '../../../commons/CountryUtils';

const ConsultantInvoiceBankPaymentSection = (props) => {
    const [accountNumberVisible, setAccountNumberVisibility] = useState(false);

    return (
        <div>
            <LightBlueAlert>
                This site uses <b>HTTPS</b> to securely exchange data via{' '}
                <b>Encryption</b>. Your bank details are safe with us.
            </LightBlueAlert>

            <div className="mt-4">
                <GenericTextInputField
                    name="consultantInvoiceBankDetails.bankName"
                    label="Bank Name"
                    type="text"
                    required={true}
                />
                <GenericTextInputField
                    name="consultantInvoiceBankDetails.accountHolderName"
                    label="Account Holder Name"
                    type="text"
                    required={true}
                />

                <div className="md:flex">
                    <div className="md:w-1/2 md:pr-1">
                        {/* id contains "otp" to signal Chrome's password manager that this is not a login password field,
                           suppressing the "Save password?" and breached-password prompts. */}
                        <GenericTextInputField
                            name="consultantInvoiceBankDetails.accountNumber"
                            label="Account Number"
                            id="bank-account-otp"
                            type={accountNumberVisible ? 'number' : 'password'}
                            required={true}
                            onFocus={() => setAccountNumberVisibility(true)}
                            onBlur={() => setAccountNumberVisibility(false)}
                        />
                    </div>

                    <div className="md:w-1/2 md:pl-1">
                        <GenericTextInputField
                            name="consultantInvoiceBankDetails.accountNumberConfirm"
                            label="Confirm Account Number"
                            type="number"
                            required={true}
                            onPaste={(e) => e.preventDefault()} // this prevents the pasting operation
                        />
                    </div>
                </div>

                <GenericTextInputField
                    name="consultantInvoiceBankDetails.bankRoutingNumber"
                    label={getBankRoutingNumberLabelByCountry(
                        props.consultantCountry
                    )}
                    type="text"
                    required={true}
                />
            </div>
        </div>
    );
};

ConsultantInvoiceBankPaymentSection.propTypes = {
    consultantCountry: PropTypes.string,
};

export default ConsultantInvoiceBankPaymentSection;
